var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.17.55.1-Setup-/-Company-/-Create-new-project-/-Step-3-/-Add-question---question-3-expand",
    transform: "translate(-1336.000000, -596.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Create-new-project",
    transform: "translate(672.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right",
    transform: "translate(218.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy-3",
    transform: "translate(0.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(32.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(279.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/02.Button/02.Text-only/01.Fill/40/Active-Copy",
    transform: "translate(123.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(12.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "create",
    mask: "url(#mask-2)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 4.000000)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0913739,0.205089462 C15.9760283,0.0783504402 15.8138565,0.00431434297 15.6425372,0.000182610857 C15.4712179,-0.00394912126 15.3056656,0.0621832071 15.1843445,0.183214506 L14.7011423,0.664072914 C14.5792003,0.786094922 14.5792003,0.983846894 14.7011423,1.1058689 L15.1441102,1.54805551 C15.2027564,1.60697529 15.2824622,1.64009916 15.3655941,1.64009916 C15.4487261,1.64009916 15.5284318,1.60697529 15.587078,1.54805551 L16.0581708,1.07930645 C16.2964516,0.841416308 16.3187172,0.453917087 16.0913739,0.205089462 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7241912,1.64063345 L6.67264284,8.6796818 C6.62988885,8.72226194 6.59881396,8.7751296 6.58240864,8.83319712 L6.25623742,9.80467954 C6.2403197,9.85837839 6.25507018,9.91648232 6.2946741,9.95608623 C6.33427802,9.99569015 6.39238194,10.0104406 6.44608079,9.99452291 L7.41678197,9.66835169 C7.47484949,9.65194637 7.52771715,9.62087149 7.57029728,9.5781175 L14.6093456,2.52578792 C14.7448796,2.38880347 14.7448796,2.16824212 14.6093456,2.03125767 L14.2206745,1.64063345 C14.0834616,1.50380609 13.8614041,1.50380609 13.7241912,1.64063345 L13.7241912,1.64063345 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2163797,5.68984406 L8.45506113,10.4605376 C8.27103843,10.6450106 8.04486171,10.7818965 7.79607808,10.8593649 L6.78436136,11.1980361 C6.29545592,11.3361018 5.77010807,11.1991099 5.41087926,10.8398811 C5.05165046,10.4806523 4.91465851,9.95530441 5.05272422,9.46639897 L5.39139541,8.45468225 C5.46863834,8.205976 5.6052518,7.97980632 5.78944149,7.7956992 L10.560135,3.0335994 C10.6495627,2.9442712 10.6763717,2.80986749 10.6280603,2.69306494 C10.5797488,2.57626238 10.4658318,2.50000672 10.3394323,2.50000672 L2.1874956,2.50000672 C0.979375141,2.50000672 0,3.47938187 0,4.68750233 L0,14.0624835 C0,15.2706039 0.979375141,16.2499791 2.1874956,16.2499791 L11.5624768,16.2499791 C12.7705972,16.2499791 13.7499724,15.2706039 13.7499724,14.0624835 L13.7499724,5.91054674 C13.7499724,5.78414726 13.6737167,5.67023025 13.5569141,5.6219188 C13.4401116,5.57360735 13.3057079,5.6004164 13.2163797,5.68984406 Z"
  }))))))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.5a818f09.svg";
export { ForwardRef as ReactComponent };